/**
 * 路由载入组件
 * @param {*} component   组件名称
 * @param {*} paths       组件路径，默认page根目录
 */
export default function load(component, paths = '') {
  // console.log(`@/page/${paths}/${component}.vue`)
  if (paths) {
    return () =>
      import(`@/page/${paths}/${component}.vue`)
  }
  return () =>
    import(`@/page/${component}.vue`)
}



// WEBPACK FOOTER //
// ./src/router/load.js